import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

interface ValidityListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (reason: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
}

const options: Array<ItemVM> = [
  { id: 'ANCORA VALIDA', value: 'ANCORA VALIDA' },
  { id: 'CARTA NON VALIDA', value: 'CARTA NON VALIDA' },
];

const ValidityListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Validità',
  id = 'validity',
}: ValidityListComponentProps): React.ReactElement => {
  const idTag = `${id}-${label}`;
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        {options?.map((item: ItemVM) => (
          <MenuItem key={item?.id} value={item?.id}>
            {item?.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ValidityListComponent.displayName = 'Validity list component';

const ValidityList = memo(ValidityListComponent);

export default ValidityList as typeof ValidityListComponent;
